import React from 'react';
import './styles/Search.css';

const SearchSuggestions = ({ suggestions, onSelect }) => {
  return (
    <div className="search-suggestions">
      {suggestions.slice(0, 5).map((station, index) => (
        <div 
          key={`${station.ev_station_id}-sugg-${index}`} 
          className="suggestion-item" 
          onClick={() => onSelect(station)}
        >
          <div className="suggestion-name">{station.station_name}</div>
          <div className="suggestion-address">{station.station_address}</div>
        </div>
      ))}
    </div>
  );
};

export default SearchSuggestions; 